import AbstractDesktopPlatformNotification
    from "~/operatorApplication/ts/platform/desktopNotification/AbstractDesktopPlatformNotification";
import AbstractDesktopPlatformNotificationWindow
    from "~/operatorApplication/ts/platform/desktopNotification/AbstractDesktopPlatformNotificationWindow";
import ElectronPlatformNotificationWindow
    from "~/operatorApplication/ts/platform/electron/ElectronPlatformNotificationWindow";

export default class ElectronPlatformNotification extends AbstractDesktopPlatformNotification {
    protected createNewWindow(): AbstractDesktopPlatformNotificationWindow {
        return new ElectronPlatformNotificationWindow();
    }
}